/* eslint-disable no-storage/no-browser-storage */
import { httpClient } from '@/utils/http-client'
import { AxiosResponse } from 'axios'
import {
    AdvisorCardType,
    AvenAdvisorLiabilityQuizLiabilityType,
    AvenAdvisorLiabilityQuizType,
    InitializeMethodFiResult,
    RequestTwoFaErrors,
    AuthFlow,
    SessionAuthenticationAuthFlow,
    RequestKbaErrors,
    IDologyQuestion,
    CreateAccountErrors,
    AvenAdvisorSignInPayload,
    ResetPasswordErrors,
    ResetPasswordPayload,
    GetAvenAdvisorCreditScoresErrors,
    AvenAdvisorNetWorth,
    AvenAdvisorNetWorthResponse,
    AvenAdvisorRentalMarketData,
    GetPayoutsAccountSetUpLinkErrors,
    LoanOffer,
    SpecialOffer,
    StartExperianBoostErrors,
    GetHeiEstimateResponse,
    AdvisorLiabilityAccountInformation,
    AvenAdvisorConfig,
    AvenAdvisorEnergyPrices,
    ReferralDepositFunnelState,
    AvenAdvisorInvestmentHoldingsResponse,
    PersonaStatus,
    AvenAdvisorNotablePersonTrades,
    AvenAdvisorNetWorthPercentileResponse,
} from 'aven_types/dist/advisor'
export {
    RequestTwoFaErrors,
    AuthFlow,
    SessionAuthenticationAuthFlow,
    RequestKbaErrors,
    CreateAccountErrors,
    ResetPasswordErrors,
    GetAvenAdvisorCreditScoresErrors,
    AvenAdvisorNetWorth,
    AvenAdvisorNetWorthResponse,
    AvenAdvisorRentalMarketData,
    GetPayoutsAccountSetUpLinkErrors,
    LoanOffer,
    SpecialOffer,
    StartExperianBoostErrors,
    AdvisorLiabilityAccountInformation,
    AvenAdvisorConfig,
    AvenAdvisorEnergyPrices,
    ReferralDepositFunnelState,
    AvenAdvisorInvestmentHoldingsResponse,
    PersonaStatus,
    AvenAdvisorNotablePersonTrades,
    AvenAdvisorNetWorthPercentileResponse,
    MethodFiLiabilityAccountType,
}
import { DocumentType, getAppInstallId } from '@/nativeWebInteraction/nativeWebInteraction'
import { MinimalContact } from '@/contacts/contacts.types'
import {
    CreditScoreDataPoint,
    GetRecentTransactionsResponse,
    GetSpendingCardDataResponse,
    GetTopMerchantsResponse,
    HomeEquityInfo,
    LienInfo,
    Subscription,
    FetchAvenAdvisorLienReportResponse,
    AvenAdvisorCreditCardRecommendationData,
    GoogleConversionName,
    FacebookPixelStep,
    MethodFiCreditScoreData,
    MethodFiCreditScoreDataPoint,
    AvenAdvisorExpiredPlaidItemsResponse,
    GetSweepstakesStatusResponse,
    CraigslistListingItem,
    AvenAdvisorPushNotificationCenterItem,
    HomeOwnershipStatus,
    AvenAdvisorLeadAccountInfoPayload,
    MaritalStatus,
    SignUpGoal,
    AvenAdvisorRentalListingResponse,
    AvenAdvisorSaleListingResponse,
    SweepstakesV2,
    SweepstakesV2Poll,
    SweepstakesV2ClaimResult,
    SweepstakesV2AttemptedEntryErrorType,
    AmazonAffiliateSearchResult,
    AmazonAffiliateSearchRequest,
    AmazonAffiliateLinkRequest,
    FreeCoffeeInfoResponse,
    AvenAdvisorBorrowingCapacityData,
    IDologyResult,
    AvenAffiliateRewardsPointsLedgerItem,
    AvenAffiliateSaleInfo,
    RedeemFreeCoffeeResponse,
    IssuedGiftCardInfo,
    AvenAdvisorWaitlistedFeature,
    StateTwoLetterCodes,
    AvenAdvisorPromoName,
    SignDocumentPayload,
    FreeCoffeeType,
    IrsFormVerificationStatus,
    HomeOwnershipVerificationStatus,
    FreeStuffPolicyCategory,
    FreeStuffEvaluationJobInfo,
    RedeemFreeCoffeePolicifiedResponse,
    FreeStuffPolicy,
    AdvisorEmbeddedAdPlacement,
    AvenAdvisorHomeValueResponse,
    PublicSweepstakesV2Winner,
    AdvisorEmbeddedCTAPlacement,
    AdPlacement,
    AvenFinancialAdCreativeInfo,
    LargePurchaseAdviceFormatted,
    UnifiedTransactionType,
    AvenAdvisorLiabilityQuizAnswersInfo,
    MethodFiLiabilityAccountType,
    MinimalTransaction,
} from 'aven_types'
import { inspect, log } from '@/utils/logger'
import { appLocalStorage, appSessionStorage, localStorageKey } from '@/utils/storage'
import { AvenAdvisorAddressPayload, AvenAdvisorLeadUpdatedField, NeighborhoodCrimeData, PrefillInformation, StreakResponse } from '@/services/api.types'
import store from '../store'
import { PubAdHubAffiliateLinkRequest } from '../../../../aven_types/dist/affiliate/pubAdHub'

const fireSessionRequest = (onSuccess: () => void): XMLHttpRequest => {
    const req = new XMLHttpRequest()
    req.onreadystatechange = function () {
        // When request ready + successful
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            const resp = JSON.parse(this.responseText)
            log.info('Setting Aven Advisor session info: %{respPayloadJson}', { respPayloadJson: JSON.stringify(resp.payload) })
            sessionStorage.setItem(localStorageKey.sessionAccessJWT, resp.payload.jwt.sessionAccessJWT)
            sessionStorage.setItem(localStorageKey.sessionId, resp.payload.sessionId)
            sessionStorage.setItem(localStorageKey.experimentsOverrides, JSON.stringify(resp.payload.experimentsOverrides))
            appSessionStorage.setItem(localStorageKey.experimentsOverrides, JSON.stringify(resp.payload.experimentsOverrides))
            // Persist V2 assignment to localStorage for cross-session persistence and reduced delay in displaying V2
            if (resp.payload.assignedV2) {
                appLocalStorage.setItem(localStorageKey.assignedV2, 'true')
            } else {
                appLocalStorage.removeItem(localStorageKey.assignedV2)
            }
            sessionStorage.setItem(localStorageKey.helocCardInfo, JSON.stringify(resp.payload.helocCardInfo))
            sessionStorage.setItem(localStorageKey.autoCardInfo, JSON.stringify(resp.payload.autoCardInfo))
            log.info('Finished firing Aven Advisor session request')
            onSuccess()
        }
        // We abort the request in getSessionInfoWithTimeout() if it takes too long.
        else if (this.readyState === XMLHttpRequest.DONE && this.status === 0) {
            log.error('getSessionId request was aborted (usually because the request took too long)')
        } else if (this.readyState === XMLHttpRequest.DONE) {
            throw new Error(`Failed to get session. XMLHttpRequest.status: ${this.status}`)
        }
    }
    req.open('POST', `${process.env.VUE_APP_API_BASE_URL}/avenAdvisor/session`)
    req.setRequestHeader('Content-Type', 'application/json')

    // window.accessToken is passed from the native app if the user is already logged in
    if (window.accessToken) {
        req.setRequestHeader('Authorization', 'Bearer ' + window.accessToken)
    } else {
        let accessToken
        const jwtTokenJson = store.state.persistedStore.jwtTokens
        try {
            if (jwtTokenJson && typeof jwtTokenJson === 'string') {
                accessToken = JSON.parse(jwtTokenJson).accessJWT
            } else if (jwtTokenJson && jwtTokenJson.accessJWT) {
                accessToken = jwtTokenJson.accessJWT
            }
        } catch (error: any) {
            log.info('unable to parse auth token from persisted store: %{errorMessage}', { errorMessage: error.message })
        }

        if (accessToken) {
            req.setRequestHeader('Authorization', 'Bearer ' + accessToken)
        }
    }

    // If we have an access token in the path of the url, we'll set it as the Authorization
    // header so our call to create a session knows which Aven Advisor lead to associate
    // with the session.
    const pathname = new URL(window.location.href).pathname
    const accessJwtMatches = pathname.match('^/a/(.+)')
    // Note that the first index of accessJwtMatches is the full string match. From index
    // 1 onward are the group matches
    if (accessJwtMatches && accessJwtMatches.length > 1) {
        req.setRequestHeader('Authorization', 'Bearer ' + accessJwtMatches[1])
    }

    // window.sessionAccessJWT is passed from the native app if it has already retrieved a session.
    // In that case, this session ID request will simply update the existing session.
    if (window.sessionAccessJWT) {
        req.setRequestHeader('SessionAuthorization', 'Bearer ' + window.sessionAccessJWT)
    }

    const appInstallId = getAppInstallId()
    log.info('fireSessionRequest => deviceGuid: %{appInstallId}', { appInstallId })

    const locallyStoredPhoneNumber = appLocalStorage.getItem(localStorageKey.phoneNumber)
    log.info('fireSessionRequest => locallyStoredPhoneNumber: %{locallyStoredPhoneNumber}', { locallyStoredPhoneNumber })

    const body = JSON.stringify({
        avenProperty: 'ADVISOR',
        resolution: window.innerWidth + 'x' + window.innerHeight,
        cookies: document.cookie,
        // Pass raw query string to allow backend to parse however it likes
        queryParams: window.location.search,
        path: window.location.pathname,
        phoneNumber: locallyStoredPhoneNumber ?? window.onboardingPhoneNumber,
        deviceGuid: appInstallId,
    })
    log.info('Requesting session from backend w/ body: %{body}', { body })
    setTimeout(() => {
        req.send(body)
    }, 100)

    return req
}

const getSessionInfo = async () => {
    return new Promise((resolve, reject) => {
        const queryParams = new URLSearchParams(window.location.search)
        const sessionIdReq = fireSessionRequest(() => {
            resolve(undefined)
        })
        // The session endpoint does synchronous work (experiment resolution, analytics writes, a Python service
        // call) and can take >5s on cold/contended calls. A 5s timeout aborted near-complete requests and forced a
        // reload cascade that piled more load on the backend, so we give it 10s before aborting.
        setTimeout(function () {
            if (!sessionStorage.getItem(localStorageKey.sessionId)) {
                log.info('Aven Advisor took too long to load session info, aborting and reloading page')
                sessionIdReq.abort()
                const reloadedQueryParam = queryParams.get('reloaded')
                const timesReloaded = reloadedQueryParam ? parseInt(reloadedQueryParam, 10) : 0
                if (timesReloaded < 3) {
                    log.info('Force reloading page because session retrieval failed, page already reloaded %{timesReloaded} times', { timesReloaded })
                    queryParams.set('reloaded', `${timesReloaded + 1}`)
                    window.location.search = queryParams.toString()
                } else {
                    log.info('Session retrieval failed after three attempts, not reloading page')
                    reject(new Error('Session info request failed after three attempts'))
                }
            }
        }, 10000)
    })
}

interface ResponseData<T> {
    success: boolean
    // Todo Technically payload's type should be `T | null`
    payload: T
    error: string
}

// This is a subset of AppLifecycleEventName in aven_backend/src/entity/appLifecycleEvent.ts
export enum AppLifecycleEventName {
    /** The web app loaded w/ in the Aven Advisor native shell */
    avenAdvisorNativeLoadedWebApp = 'avenAdvisorNativeLoadedWebApp',
    /** The web app initialized Vue (i.e. the web app was ready for the user to interact with) */
    avenAdvisorNativeWebAppInitializedVue = 'avenAdvisorNativeWebAppInitializedVue',
    /** Event measuring the time from app open to Today tab displaying its UI */
    avenAdvisorTimeToInteractive = 'avenAdvisorTimeToInteractive',
}

export const createLifecycleEvent = async (sessionIdentifier: string, eventName: AppLifecycleEventName, eventData: object): Promise<AxiosResponse<void>> => {
    return await httpClient.post('/avenAdvisor/createLifecycleEvent', {
        sessionIdentifier,
        eventName,
        eventData,
    })
}

// Fetches the feed card order from the backend
export const getFeedCardOrder = async (): Promise<AdvisorCardType[]> => {
    const response = await httpClient.get('/avenAdvisor/feedCards')
    return response.data.cards
}

export type AvenAdvisorRequestTwoFaPayload =
    | {
          phoneNumber: string
      }
    | { email: string }

const requestTwoFactor = async (payload: AvenAdvisorRequestTwoFaPayload): Promise<AxiosResponse<ResponseData<{ sid: string }>>> => {
    return await httpClient.post('/avenAdvisor/requestTwoFactorCode', payload)
}

const routeToAuthFlow = async (phoneNumber: string): Promise<AxiosResponse<void>> => {
    return await httpClient.post('/avenAdvisor/routeToAuthFlow', { phoneNumber })
}

export const submitHausQAndAQuestion = async (question: string): Promise<AxiosResponse<ResponseData<{ authFlow: AuthFlow }>>> => {
    return await httpClient.post('/avenAdvisor/addHausQAndAQuestion', { question })
}

export interface AvenAdvisorCheckTwoFaCodePayload {
    phoneNumber: string
    email: string
    otpSid: string
    otpCode: string
}

const checkTwoFa = async (payload: AvenAdvisorCheckTwoFaCodePayload): Promise<AxiosResponse<ResponseData<{ authFlow: AuthFlow } | { errorText: string }>>> => {
    return await httpClient.post('/avenAdvisor/checkTwoFa', payload)
}

const checkTwoFaForPhoneNumberChange = async (payload: AvenAdvisorCheckTwoFaCodePayload): Promise<AxiosResponse<ResponseData<{ authFlow: AuthFlow } | { errorText: string }>>> => {
    return await httpClient.post('/avenAdvisor/checkTwoFaForPhoneNumberChange', payload)
}

interface AddressPayload {
    addressStreet: string
    secondaryAddressUnit: string | null
    addressCity: string
    addressState: string
    addressPostalCode: string
    googlePlaceId?: string
}

export const validateAddress = async (payload: AddressPayload): Promise<AxiosResponse<ResponseData<{ wasCorrected: boolean; validatedAddress: AddressPayload }>>> => {
    return httpClient.post('/avenAdvisor/validateAddress', payload)
}

export const updateIrsAddress = async (payload: AddressPayload): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/updateIrsAddress', payload)
}

interface RequestKbQuestionsPayload {
    firstName: string
    lastName: string
    phoneNumber: string
    addressStreet: string
    addressCity: string
    addressState: string
    addressPostalCode: string
    dateOfBirth: Date
    ssnLast4: string
}

export const requestKbaQuestions = async (
    payload: RequestKbQuestionsPayload
): Promise<AxiosResponse<ResponseData<{ idologyQueryId: string; status: IDologyResult; questions: IDologyQuestion[]; idologySsnQueryId: string }>>> => {
    return await httpClient.post('/avenAdvisor/requestKbaQuestions', payload)
}

interface CheckKbaQuestionAnswersPayload {
    idologyQueryId: string
    answers: { questionType: string; answer: string }[]
}

export const checkKbaQuestionAnswers = async (payload: CheckKbaQuestionAnswersPayload): Promise<AxiosResponse<ResponseData<{ idologyQueryId: string; status: IDologyResult }>>> => {
    return await httpClient.post('/avenAdvisor/checkKbaQuestionAnswers', payload)
}

interface RequestKbaChallengeQuestionPayload {
    idologyQueryId: string
}

export const requestKbaChallengeQuestion = async (payload: RequestKbaChallengeQuestionPayload): Promise<AxiosResponse<ResponseData<{ idologyQueryId: string; questions: IDologyQuestion[] }>>> => {
    return await httpClient.post('/avenAdvisor/requestKbaChallengeQuestion', payload)
}

export const checkKbaChallengeQuestionAnswers = async (payload: CheckKbaQuestionAnswersPayload): Promise<AxiosResponse<ResponseData<{ idologyQueryId: string; status: IDologyResult }>>> => {
    return await httpClient.post('/avenAdvisor/checkKbaChallengeQuestionAnswers', payload)
}

export enum HelocHomeAdStatus {
    SHOW_OFFER = 'SHOW_OFFER',
    SHOW_AD = 'SHOW_AD',
    REQUEST_MARITAL_STATUS = 'REQUEST_MARITAL_STATUS',
    GENERATING_OFFER = 'GENERATING_OFFER',
}

const MARITAL_STATUS_TO_TEXT: { [T in MaritalStatus]: string } = {
    [MaritalStatus.MARRIED]: 'Married',
    [MaritalStatus.UNMARRIED]: 'Unmarried',
    [MaritalStatus.SEPARATED]: 'Separated',
    [MaritalStatus.DOMESTIC_PARTNERSHIP_CIVIL_UNION]: 'Unmarried',
}

const HOME_OWNERSHIP_STATUS_TO_TEXT: { [T in HomeOwnershipStatus]: string } = {
    [HomeOwnershipStatus.OWN]: 'I own this home',
    [HomeOwnershipStatus.RENT]: 'I rent',
}

export interface SignDocumentAckMetadataPayload {
    signature: string
    signatureType: string
    localTimestamp: Date // timestamp of when the signature was created in browser's local time using js's Date.toString(): DayOfWeek Month Day Year Hour:Minute:Second GMTOffset (TimeZone)
    browserEvent: string // Serialized browser event that triggered the signature
    urlPath: string
}

export const beginIrsFormVerification = async (metadata: SignDocumentAckMetadataPayload): Promise<AxiosResponse<null>> => {
    return await httpClient.post('/avenAdvisor/beginIrsFormVerification', {
        metadata,
    })
}

export const setStatedIncome = async (statedIncome: number, statedIncomeHousehold: number): Promise<AxiosResponse<null>> => {
    return await httpClient.post('/avenAdvisor/setStatedIncome', {
        statedIncome,
        statedIncomeHousehold,
    })
}

export interface AvenAdvisorCreateAccountPayload extends AvenAdvisorAddressPayload {
    ssnLast4: string
    dateOfBirth: Date
    phoneNumber: string
    email?: string | null
    firstName: string
    lastName: string
    secondaryAddressDesignator?: string | null
    otpSid: string
    otpCode: string
    idologyQueryId: string
    idologySsnQueryId: string
    inviteCode?: string
    consentToCreditOfferDisclosuresHash?: string
    consentToExperianBoostDataSharingHash?: string
    consentToMethodFiTosGitHash?: string
    eSignConsentGitHash?: string
    maritalStatus: MaritalStatus
    isWebOrigination?: boolean
}

interface JwtTokens {
    accessJWT: string
    refreshJWT: string
    accessExpiry: number
}

interface CreateAccountResponse {
    jwtTokens?: JwtTokens
    reenterInviteCode: boolean
    fullSsnNeeded?: boolean
}

const createAccount = async (payload: AvenAdvisorCreateAccountPayload): Promise<AxiosResponse<ResponseData<CreateAccountResponse>>> => {
    return await httpClient.post('/avenAdvisor/account', payload)
}

const signIn = async (payload: AvenAdvisorSignInPayload): Promise<AxiosResponse<ResponseData<{ jwtTokens: JwtTokens }>>> => {
    return await httpClient.post('/avenAdvisor/signIn', payload)
}

const resetPassword = async (payload: ResetPasswordPayload): Promise<AxiosResponse<ResponseData<{ jwtTokens: JwtTokens }>>> => {
    return httpClient.post('/avenAdvisor/resetPassword', payload)
}

export const doesEmailExistForPhoneNumber = async (payload: { phoneNumber: string; otpSid?: string; otpCode?: string }): Promise<AxiosResponse<ResponseData<{ emailExists: boolean }>>> => {
    return httpClient.post('/avenAdvisor/doesEmailExistForPhoneNumber', payload)
}

export const checkAccountBlock = async (): Promise<AxiosResponse<ResponseData<{ isAccountBlocked: boolean }>>> => {
    return httpClient.get('/avenAdvisor/checkAccountBlock')
}

export const getAvenAdvisorLeadAccountInfo = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorLeadAccountInfoPayload>>> => {
    return await httpClient.get('/avenAdvisor/accountInfo')
}

export const editAccountInformation = async (
    payload: Record<AvenAdvisorLeadUpdatedField, string>
): Promise<AxiosResponse<ResponseData<{ otpSid: string | null } | { errorCode: RequestTwoFaErrors }>>> => {
    return await httpClient.post('/avenAdvisor/editAccountInformation', payload)
}

export const setMaritalStatusToAdvisorLead = async (maritalStatus: MaritalStatus): Promise<AxiosResponse<ResponseData<{}>>> => {
    return await httpClient.post('/avenAdvisor/setMaritalStatus', { maritalStatus })
}

export const generateLinkToAutoApplication = async (): Promise<AxiosResponse<ResponseData<{ autoApplicationUrl: string }>>> => {
    return await httpClient.get('/avenAdvisor/generateLinkToAutoApplication')
}

// remove history?, kept for backcompat
export const getCreditScores = async (): Promise<
    AxiosResponse<ResponseData<{ ficoScore: number | null; vantageScore: number | null; dateOfScores: Date; dateOfNextScores: Date; history?: CreditScoreDataPoint[] }>>
> => {
    return await httpClient.get('/avenAdvisor/creditScores')
}

export const intializeMethodFiCreditScoreData = async (): Promise<AxiosResponse<ResponseData<{}>>> => {
    return await httpClient.post('/avenAdvisor/initializeMethodFiCreditScore')
}

export const getMethodFiCreditScoreData = async (allowCachedResult?: boolean): Promise<AxiosResponse<ResponseData<MethodFiCreditScoreData | null>>> => {
    return await httpClient.get('/avenAdvisor/getMethodFiCreditScore', { params: { allowCachedResult } })
}

export const getCreditScoreHistory = async (): Promise<AxiosResponse<ResponseData<{ history: CreditScoreDataPoint[] }>>> => {
    return await httpClient.get('/avenAdvisor/creditScoreHistory')
}

export const getMethodFiCreditScoreHistory = async (): Promise<AxiosResponse<ResponseData<{ history: MethodFiCreditScoreDataPoint[] }>>> => {
    return await httpClient.get('/avenAdvisor/methodFiCreditScoreHistory')
}

const getTotalDebt = async () => {
    return await httpClient.get('/avenAdvisor/getTotalDebt')
}

export interface AssetSnapshot {
    date: Date
    value: number
}

let getCashAndStockPromise: Promise<AxiosResponse<ResponseData<AvenAdvisorNetWorthResponse>>> | null = null

export const getCashAndStock = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorNetWorthResponse>>> => {
    if (!getCashAndStockPromise) {
        log.info('Fetching cash and stock')
        getCashAndStockPromise = httpClient.get('/avenAdvisor/getCashAndStock')
        getCashAndStockPromise.finally(() => {
            getCashAndStockPromise = null
        })
    }
    log.info('Returning cash and stock promise')
    return await getCashAndStockPromise
}

let getHomeValuePromise: Promise<AxiosResponse<ResponseData<AvenAdvisorHomeValueResponse | null>>> | null = null

export const getHomeValue = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorHomeValueResponse | null>>> => {
    if (!getHomeValuePromise) {
        log.info('Fetching home value')
        getHomeValuePromise = httpClient.get('/avenAdvisor/homeValue')
        getHomeValuePromise.finally(() => {
            getHomeValuePromise = null
        })
    }
    log.info('Returning home value promise')
    return await getHomeValuePromise
}

export interface GetHomeOwnershipStatusResponse {
    homeOwnershipStatus: HomeOwnershipStatus
}

let getHomeOwnershipStatusPromise: Promise<AxiosResponse<ResponseData<GetHomeOwnershipStatusResponse>>> | null = null

export const getHomeOwnershipStatus = async (): Promise<AxiosResponse<ResponseData<GetHomeOwnershipStatusResponse>>> => {
    if (!getHomeOwnershipStatusPromise) {
        log.info('Fetching home ownership status')
        getHomeOwnershipStatusPromise = httpClient.get('/avenAdvisor/homeOwnershipStatus')
        getHomeOwnershipStatusPromise.finally(() => {
            getHomeOwnershipStatusPromise = null
        })
    }
    log.info('Returning home ownership status promise')
    return await getHomeOwnershipStatusPromise
}

export interface NeighborhoodDataResponse {
    medianSalePrice: number
    lastUpdatedAt: Date
    history: {
        medianSalePrice: number
        date: Date
    }[]
}

let getNeighborhoodReportPromise: Promise<AxiosResponse<ResponseData<NeighborhoodDataResponse>>> | null = null

export const getNeighborhoodReport = async (): Promise<AxiosResponse<ResponseData<NeighborhoodDataResponse>>> => {
    if (!getNeighborhoodReportPromise) {
        log.info('Fetching neighborhood report')
        getNeighborhoodReportPromise = httpClient.get('/avenAdvisor/getNeighborhoodReport')
        getNeighborhoodReportPromise.finally(() => {
            getNeighborhoodReportPromise = null
        })
    }
    log.info('Returning neighborhood report promise')
    return await getNeighborhoodReportPromise
}

let getNeighborhoodRentPricesPromise: Promise<AxiosResponse<ResponseData<AvenAdvisorRentalMarketData | null>>> | null = null

export const getNeighborhoodRentPrices = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorRentalMarketData | null>>> => {
    if (!getNeighborhoodRentPricesPromise) {
        log.info('Fetching neighborhood rent prices')
        getNeighborhoodRentPricesPromise = httpClient.get('/avenAdvisor/getNeighborhoodRentPrices')
        getNeighborhoodRentPricesPromise.finally(() => {
            getNeighborhoodRentPricesPromise = null
        })
    }
    log.info('Returning neighborhood rent prices promise')
    return await getNeighborhoodRentPricesPromise
}

let getSaleListingsPromise: Promise<AxiosResponse<ResponseData<AvenAdvisorSaleListingResponse | null>>> | null = null

export const getSaleListings = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorSaleListingResponse | null>>> => {
    if (!getSaleListingsPromise) {
        log.info('Fetching sale listings')
        getSaleListingsPromise = httpClient.get('/avenAdvisor/getSaleListings')
        getSaleListingsPromise.finally(() => {
            getSaleListingsPromise = null
        })
    }
    log.info('Returning sale listings promise')
    return await getSaleListingsPromise
}

let getRentListingsPromise: Promise<AxiosResponse<ResponseData<AvenAdvisorRentalListingResponse | null>>> | null = null

export const getRentListings = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorRentalListingResponse | null>>> => {
    if (!getRentListingsPromise) {
        log.info('Fetching rent listings')
        getRentListingsPromise = httpClient.get('/avenAdvisor/getRentalListings')
        getRentListingsPromise.finally(() => {
            getRentListingsPromise = null
        })
    }
    log.info('Returning rent listings promise')
    return await getRentListingsPromise
}

const getInviteCode = async () => {
    return await httpClient.get('/avenAdvisor/getInviteCode')
}

export const requestPlaidLinkToken = async (getHostedLinkToken: boolean): Promise<AxiosResponse<ResponseData<{ linkToken: string; hostedLinkUrl?: string }>>> => {
    log.info('Requesting plaid link token with getHostedLinkToken: %{getHostedLinkToken}', { getHostedLinkToken })
    return await httpClient.get('/avenAdvisor/requestPlaidToken', { params: { getHostedLinkToken } })
}

export const requestPlaidLinkUpdateToken = async (institutionId: string, getHostedLinkToken: boolean): Promise<AxiosResponse<ResponseData<{ linkUpdateToken: string; hostedLinkUrl?: string }>>> => {
    log.info('Requesting plaid link update token with institutionId: %{institutionId} and getHostedLinkToken: %{getHostedLinkToken}', { institutionId, getHostedLinkToken })
    return await httpClient.get('/avenAdvisor/requestPlaidUpdateToken', { params: { institutionId, getHostedLinkToken } })
}

const plaidReportFetchState = async (itemId: string) => {
    return await httpClient.get('/avenAdvisor/plaidReportFetchState', { params: { itemId } })
}

// institutionInfo = institutionName
const startPlaidReportFetch = async (plaidPublicToken: string) => {
    return await httpClient.post('/avenAdvisor/startPlaidReportFetch', {
        publicToken: plaidPublicToken,
    })
}

export const getPlaidPublicTokenReportState = async (plaidLinkToken: string): Promise<AxiosResponse<ResponseData<{ plaidReportId: number | undefined; publicToken: string | undefined }>>> => {
    return await httpClient.get('/avenAdvisor/getPlaidPublicTokenReportState', { params: { linkToken: plaidLinkToken } })
}

export const getPlaidPublicTokenForLinkTokenSession = async (plaidLinkToken: string): Promise<AxiosResponse<ResponseData<{ publicToken: string }>>> => {
    return await httpClient.get('/avenAdvisor/getPublicTokenCreatedForLinkTokenSessionForAdvisor', { params: { linkToken: plaidLinkToken } })
}

export const getSuccessfulSignOnBonusCount = async (): Promise<AxiosResponse<ResponseData<{ numberOfBonusesPaid: number; maxReferralsPerMonth: number }>>> => {
    return await httpClient.get('/avenAdvisor/getSuccessfulSignOnBonusCount')
}

export const getLegalDocument = async (docType: DocumentType, applicantReturnToken2?: string, extraDocumentRenderData?: any): Promise<AxiosResponse> => {
    return await httpClient.get('/avenAdvisor/legal', {
        responseType: 'blob',
        params: {
            docType,
            returnTokenForAssociatedApplicant: applicantReturnToken2,
            extraDocumentRenderData,
        },
    })
}

export const get4506cDocumentWithSsn = async (ssn: string): Promise<AxiosResponse<ResponseData<{ htmlString: string }>>> => {
    return await httpClient.post('/avenAdvisor/get4506cDocumentWithSsn', {
        ssn,
    })
}

const updateSocialSecurity = async (ssn: string) => {
    return await httpClient.post('/avenAdvisor/updateSsn', {
        ssn: ssn,
    })
}

export const getReferralInfo = async (): Promise<
    AxiosResponse<
        ResponseData<{
            pendingReferralDollars: number
            payoutsEnabled: boolean
            remediationMessage?: string
            spinToWinEnabled: boolean
            availableSpins: number
            lastSuccessfulSpinAmount: number | null
        }>
    >
> => {
    return await httpClient.get('/avenAdvisor/getReferralInfo')
}

export const spinTheWheel = async (): Promise<AxiosResponse<ResponseData<{ dollarAmount: number }>>> => {
    return await httpClient.get('/avenAdvisor/spinTheWheel')
}

export const newSpinForAvenEmployee = async (): Promise<AxiosResponse<ResponseData<undefined>>> => {
    return await httpClient.get('/avenAdvisor/newSpinForAvenEmployee')
}

const getPayoutsAccountSetUpLink = async (): Promise<AxiosResponse<ResponseData<{ accountSetUpLink?: string }>>> => {
    return await httpClient.get('/avenAdvisor/payoutsAccountSetUpLink')
}

export const getPayoutsDashboardLink = async (): Promise<AxiosResponse<ResponseData<{ dashboardLink?: string }>>> => {
    return await httpClient.get('/avenAdvisor/getPayoutsDashboardLink')
}

export const saveContacts = async (contacts: MinimalContact[]) => {
    return await httpClient.post('/avenAdvisor/saveContacts', { contacts })
}

export const getContactsAlreadyOnAdvisor = async (): Promise<AxiosResponse<ResponseData<{ existingUsersPhoneNumbers: string[]; existingUsersEmails: string[] }>>> => {
    return await httpClient.get('/avenAdvisor/getContactsAlreadyOnAdvisor')
}

export const unlinkPlaidForCurrentUser = async (
    phoneNumber: string
): Promise<AxiosResponse<ResponseData<{ successfullyUnlinkedAvenAdvisorLeadIds: number[]; failedtoUnlinkAvenAdvisorLeadIds: number[] }>>> => {
    return await httpClient.post('/avenAdvisor/ops/unlinkPlaidReportsForPhoneNumber', { phoneNumber })
}

const initiateCreditOffer = async (fcraLanguage: string, tcpaLanguage: string): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/initiateCreditOfferCreation', { fcraLanguage, tcpaLanguage })
}

type PollForCreditOffersResponse = null | { inProgress: boolean; offers: LoanOffer[]; specialOffers: SpecialOffer[] }

const pollForCreditOffers = async (): Promise<AxiosResponse<ResponseData<PollForCreditOffersResponse>>> => {
    return await httpClient.get('/avenAdvisor/pollForCreditOffers')
}

interface IllustrativeSavingsExampleResponse {
    lineSize: number
    baseline: {
        apr: number
        aprSource: string | null
        firstPayment: number
        numPeriods: number
        totalPaid: number
        totalPayments: number
    }
    comparison: {
        apr: number
        firstPayment: number
        numPeriods: number
        totalPaid: number
        totalPayments: number
    }
}

const getIllustrativeSavingsExample = async (comparisonApr: number): Promise<AxiosResponse<ResponseData<IllustrativeSavingsExampleResponse>>> => {
    return await httpClient.post('/avenAdvisor/getIllustrativeSavingsExample', { comparisonApr })
}

export const consentToShareDataWithExperianBoost = async (payload: { codeHash: string }): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/consentToShareDataWithExperianBoost', payload)
}

export const getConsentToShareDataWithExperianBoost = async (): Promise<AxiosResponse<ResponseData<{ hash: string | null }>>> => {
    return await httpClient.get('/avenAdvisor/getConsentToShareDataWithExperianBoost')
}

export const acceptCreditOfferDisclosure = async (payload: { codeHash: string }): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/acceptCreditOfferDisclosure', payload)
}

export const acceptEsignConsent = async (payload: { codeHash: string }): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/acceptEsignConsent', payload)
}

export const consentToContactUpload = async (payload: { codeHash: string }): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/consentToContactUpload', payload)
}

export const getIsPlaidRequiredForPaidReferral = async (): Promise<AxiosResponse<ResponseData<{ isPlaidRequiredForPaidReferral: boolean }>>> => {
    return await httpClient.get('/avenAdvisor/getIsPlaidRequiredForPaidReferral')
}

export const startExperianBoost = async (): Promise<AxiosResponse<ResponseData<{ redirectUrl?: string }>>> => {
    return await httpClient.get('/avenAdvisor/startExperianBoost')
}

export const setDateOfBirth = async (dateOfBirth: string): Promise<AxiosResponse<ResponseData<any>>> => {
    return await httpClient.post('/avenAdvisor/setDateOfBirth', { dateOfBirth })
}

export const setEmailAndSignUpGoal = async (email: string, signUpGoal: SignUpGoal | null): Promise<AxiosResponse<ResponseData<any>>> => {
    return await httpClient.post('/avenAdvisor/setEmailAndSignUpGoal', { email, signUpGoal })
}

export const getHeiEstimate = async (): Promise<AxiosResponse<ResponseData<GetHeiEstimateResponse>>> => {
    return await httpClient.get('/avenAdvisor/getHeiEstimate')
}

export interface AvenAdvisorLiabilitySnapshot {
    balanceCents: number
    updatedDate: Date
}

let getLiabilityAccountsPromise: Promise<AxiosResponse<ResponseData<{ liabilityAccounts: AdvisorLiabilityAccountInformation[]; liabilityAccountsHistory: AvenAdvisorLiabilitySnapshot[] }>>> | null =
    null

export const getLiabilityAccounts = async (payload: {
    codeHash: string
}): Promise<AxiosResponse<ResponseData<{ liabilityAccounts: AdvisorLiabilityAccountInformation[]; liabilityAccountsHistory: AvenAdvisorLiabilitySnapshot[] }>>> => {
    if (!getLiabilityAccountsPromise) {
        log.info('Fetching liability accounts')
        getLiabilityAccountsPromise = httpClient.post('/avenAdvisor/getLiabilityAccounts', payload)
        getLiabilityAccountsPromise.finally(() => {
            getLiabilityAccountsPromise = null
        })
    }
    log.info('Returning liability accounts promise')
    return await getLiabilityAccountsPromise
}

let getConfigPromise: Promise<AxiosResponse<ResponseData<{ config: AvenAdvisorConfig }>>> | null = null

export const getConfig = async (): Promise<AxiosResponse<ResponseData<{ config: AvenAdvisorConfig }>>> => {
    if (!getConfigPromise) {
        log.info('Fetching config')
        getConfigPromise = httpClient.get('/avenAdvisor/config')
        getConfigPromise.finally(() => {
            getConfigPromise = null
        })
    }
    log.info('Returning config promise')
    return await getConfigPromise
}

export const setHomeownerStatusForEmployees = async (payload: { homeOwnershipStatus: HomeOwnershipStatus }): Promise<AxiosResponse<ResponseData<null>>> => {
    return httpClient.post('/avenAdvisor/setHomeownerStatusForEmployees', payload)
}

export interface AlpacaEquityWrapperResponse {
    stockBars: Record<string, AlpacaEquityWrapper> | null
}
export interface AlpacaEquityWrapper {
    bars: AlpacaBar[]
    priorClosePrice: number
    todayClosePrice: number
    fullName: string
}
export interface AlpacaBar {
    Symbol: string | undefined
    ClosePrice: number | undefined
    Volume: number | undefined
    Timestamp: string | undefined
}

let getEnergyPricesPromise: Promise<AxiosResponse<ResponseData<AvenAdvisorEnergyPrices | null>>> | null = null

export const getEnergyPrices = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorEnergyPrices | null>>> => {
    if (!getEnergyPricesPromise) {
        log.info('Fetching energy prices')
        getEnergyPricesPromise = httpClient.get('/avenAdvisor/getEnergyPrices')
        getEnergyPricesPromise.finally(() => {
            getEnergyPricesPromise = null
        })
    }
    log.info('Returning energy prices promise')
    return await getEnergyPricesPromise
}

let getStockBarsPromise: Promise<AxiosResponse<ResponseData<AlpacaEquityWrapperResponse | null>>> | null = null

export const getStockBars = async (): Promise<AxiosResponse<ResponseData<AlpacaEquityWrapperResponse | null>>> => {
    if (!getStockBarsPromise) {
        log.info('Fetching stock bars')
        getStockBarsPromise = httpClient.get('/avenAdvisor/getStockBars')
        getStockBarsPromise.finally(() => {
            getStockBarsPromise = null
        })
    }
    log.info('Returning stock bars promise')
    return await getStockBarsPromise
}

export interface VehicleInformation {
    valuation: number
    valuationDate: Date
    nextUpdateAvailableDate: Date
    make: string
    model: string
    year: number
    history: { value: number; date: Date }[]
}
export const retrieveVehicleValue = async (): Promise<AxiosResponse<ResponseData<VehicleInformation | null>>> => {
    return await httpClient.get('/avenAdvisor/retrieveVehicleValue')
}

export const createVehicleIfNotExists = async (licensePlateState: string, licensePlate: string): Promise<AxiosResponse<ResponseData<VehicleInformation | null>>> => {
    return await httpClient.post('/avenAdvisor/createVehicleIfNotExists', { licensePlateState, licensePlate })
}

export const getTopMerchants = async (): Promise<AxiosResponse<ResponseData<GetTopMerchantsResponse>>> => {
    return await httpClient.get('/avenAdvisor/getTopMerchants')
}

export interface GetSubscriptionsResponse {
    nextUpdateAvailableDate: Date | null
    lastUpdatedDate: Date | null
    subscriptions: Subscription[]
    institutionNames: string[]
}

export interface GetWeeklyTransactionsResponse {
    transactions: MinimalTransaction[]
    institutionNames: string[]
    snapshotDate: Date
    weeklySpending?: { lastDayOfWeek: Date; spending: number }[]
}

export const DEFAULT_NUM_WEEKLY_TRANSACTIONS_TO_RETURN = 20
export const DEFAULT_NUM_OF_DAYS_TO_RETURN_RECENT_TRANSACTIONS = 7

export const getWeeklyTransactions = async (numTransactionsToReturn: number): Promise<AxiosResponse<ResponseData<GetWeeklyTransactionsResponse>>> => {
    return await httpClient.get('/avenAdvisor/getWeeklyTransactions', { params: { numTransactionsToReturn } })
}

export const getRecentTransactions = async (lastNDays: number): Promise<AxiosResponse<ResponseData<GetRecentTransactionsResponse>>> => {
    return await httpClient.get('/avenAdvisor/getRecentTransactions', { params: { lastNDays } })
}

let getTransactionsBetweenDatesPromise: Promise<AxiosResponse<ResponseData<GetRecentTransactionsResponse>>> | null = null

export const getTransactionsBetweenDates = async (startDate: string, endDate: string): Promise<AxiosResponse<ResponseData<GetRecentTransactionsResponse>>> => {
    if (!getTransactionsBetweenDatesPromise) {
        log.info('Fetching transactions between dates')
        getTransactionsBetweenDatesPromise = httpClient.get('/avenAdvisor/getTransactionsBetweenDates', { params: { startDate, endDate } })
        getTransactionsBetweenDatesPromise.finally(() => {
            getTransactionsBetweenDatesPromise = null
        })
    }
    log.info('Returning transactions between dates promise')
    return await getTransactionsBetweenDatesPromise
}

let getNotificationDataWithPushIdPromise: Promise<AxiosResponse<ResponseData<AvenAdvisorPushNotificationCenterItem | null>>> | null = null

export const getNotificationDataWithPushId = async (pushId: string, enforceLatest: boolean = false): Promise<AxiosResponse<ResponseData<AvenAdvisorPushNotificationCenterItem | null>>> => {
    if (!getNotificationDataWithPushIdPromise) {
        log.info('Fetching notification data with push id')
        getNotificationDataWithPushIdPromise = httpClient.get('/avenAdvisor/getNotificationDataWithPushId', { params: { pushId: +pushId, enforceLatest } })
        getNotificationDataWithPushIdPromise.finally(() => {
            getNotificationDataWithPushIdPromise = null
        })
    }
    log.info('Returning notification data with push id promise')
    return await getNotificationDataWithPushIdPromise
}

export const getSpendingCardData = async (): Promise<AxiosResponse<ResponseData<GetSpendingCardDataResponse>>> => {
    return await httpClient.get('/avenAdvisor/getSpendingCardData')
}

export const getSubscriptions = async (): Promise<AxiosResponse<ResponseData<GetSubscriptionsResponse>>> => {
    return await httpClient.get('/avenAdvisor/getSubscriptions')
}

export const updateHomeAddressAndOwnershipStatus = async (updatePayload: AvenAdvisorAddressPayload): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/updateHomeAddressAndOwnershipStatus', updatePayload)
}

export const stockSearch = async (searchTerm: string, limit: number): Promise<AxiosResponse<ResponseData<Record<string, AlpacaEquityWrapper> | null>>> => {
    return await httpClient.get('/avenAdvisor/stockSearch', {
        params: {
            input: searchTerm,
            limit,
        },
    })
}

export const setEquitiesTickers = async (newTickers: string[]): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/setEquitiesTickers', { newTickers })
}

export const setReferralDepositFunnelState = async (funnelState: ReferralDepositFunnelState): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/setReferralDepositFunnelState', { funnelState: funnelState })
}

export interface ReferralDepositFunnelStateResponse {
    currentFunnelState: ReferralDepositFunnelState
}

export const getReferralDepositFunnelState = async (): Promise<AxiosResponse<ResponseData<ReferralDepositFunnelStateResponse>>> => {
    return await httpClient.get('/avenAdvisor/getReferralDepositFunnelState')
}

export const deleteCurrentAccount = async (accountDeleteReason: string): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/deleteAccount', { accountDeleteReason })
}

export const getSweepstakesStatus = async (): Promise<AxiosResponse<ResponseData<GetSweepstakesStatusResponse | null>>> => {
    return await httpClient.get('/avenAdvisor/getSweepstakesStatus')
}

export const getSweepstakesV2 = async (): Promise<AxiosResponse<ResponseData<SweepstakesV2 | null>>> => {
    return await httpClient.get('/avenAdvisor/getSweepstakesV2')
}

export const enterSweepstakesV2 = async (): Promise<AxiosResponse<ResponseData<{ error: SweepstakesV2AttemptedEntryErrorType | null }>> | null> => {
    return await httpClient.post('/avenAdvisor/enterSweepstakesV2')
}

export const updateSweepstakesV2Heartbeat = async (): Promise<AxiosResponse<ResponseData<null>> | null> => {
    return await httpClient.post('/avenAdvisor/updateSweepstakesV2Presence')
}

export const pollForSweepstakesV2Winner = async (): Promise<AxiosResponse<ResponseData<SweepstakesV2Poll>> | null> => {
    return await httpClient.get('/avenAdvisor/pollSweepstakesV2Winner')
}

export const isEligibleForSweepstakesV2 = async (): Promise<AxiosResponse<ResponseData<{ eligible: boolean; reason: string | null }>>> => {
    return await httpClient.get('/avenAdvisor/isEligibleForSweepstakesV2')
}

export const claimPrizeIfSweepstakesV2Winner = async (): Promise<AxiosResponse<ResponseData<SweepstakesV2ClaimResult>> | null> => {
    return await httpClient.get('/avenAdvisor/claimSweepstakesV2Prize')
}

export const getCreditScoreTips = async (forceRefresh = false): Promise<AxiosResponse<ResponseData<{ tips: { tipTitle: string; tipBody: string }[] } | null>>> => {
    return await httpClient.post('/avenAdvisor/getCreditScoreTips', { forceRefresh })
}

export const getPrefillInformation = async (
    phoneNumber: string,
    last4Ssn: string,
    otpSid?: string,
    otpCode?: string
): Promise<AxiosResponse<ResponseData<{ prefillInformation: PrefillInformation }>>> => {
    return await httpClient.post('/avenAdvisor/getPrefillInformation', { phoneNumber, last4Ssn, otpSid, otpCode })
}

export const getIsEligibleForPaidReferrals = async (): Promise<AxiosResponse<ResponseData<{ isEligibleForPaidReferrals: boolean }>>> => {
    return await httpClient.get('/avenAdvisor/getIsEligibleForPaidReferrals')
}

export const validateInviteCode = async (inviteCode: string): Promise<AxiosResponse<ResponseData<{ isValid: true } | { isValid: false; message: string }>>> => {
    return await httpClient.get('/avenAdvisor/validateInviteCode', { params: { inviteCode } })
}

export const copyReferrerPolicies = async (inviteCode: string, refereePhoneNumber: string): Promise<AxiosResponse<ResponseData<{ copiedPolicies: FreeStuffPolicy[] }>>> => {
    return await httpClient.post('/avenAdvisor/assignReferrerPolicies', { inviteCode, refereePhoneNumber })
}

export const copyReferrerPromos = async (inviteCode: string, refereePhoneNumber: string): Promise<AxiosResponse<ResponseData<{ copiedPromosCount: number }>>> => {
    return await httpClient.get('/avenAdvisor/copyReferrerPromos', { params: { inviteCode, refereePhoneNumber } })
}

export const assignPromosFromDMInviteCode = async (inviteCode: string, refereePhoneNumber: string): Promise<AxiosResponse<ResponseData<{ assignedPromoCodes: number }>>> => {
    return await httpClient.get('/avenAdvisor/assignPromosFromDMInviteCode', { params: { inviteCode, refereePhoneNumber } })
}

export const checkHasGottenRefereeBonus = async (phoneNumber: string): Promise<AxiosResponse<ResponseData<{ hasGottenRefereeBonus: boolean }>>> => {
    return await httpClient.get('/avenAdvisor/checkHasGottenRefereeBonus', { params: { phoneNumber } })
}

export const saveAvenFridaysSweepstakesRecord = async (payload: { entryButtonClicked?: boolean; tweetButtonClicked?: boolean }): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/saveAvenFridaysSweepstakesRecord', payload)
}

export const submitCuSurvey = async (payload: {
    currentFinancialInstitutions: string[]
    initialHavenAccountTransferAmount: string
    monthlyHavenAccountTransferAmount: string
    loanServicesInterest: string[]
    requiredServices: string[]
    servicesToSwitchToHaven: string[]
    importantAspectOfLoan: string[]
    wouldSignUpForHaven: boolean
}): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/submitCuSurvey', payload)
}

export const updateSsnDobForEmployee = async (ssn: string, dateOfBirth: Date): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/updateSsnDobForEmployee', { ssn, dateOfBirth })
}

export const createVisitAndUpdateStreak = async (): Promise<AxiosResponse<ResponseData<StreakResponse | null>>> => {
    return await httpClient.post('/avenAdvisor/createVisitAndUpdateStreak', {})
}

export interface PayoutHistoryItem {
    amount: number
    type: string
    status: string
    moreInformationText?: string
}
export const getPayoutHistory = async (): Promise<AxiosResponse<ResponseData<{ payouts: PayoutHistoryItem[] }>>> => {
    return await httpClient.get('/avenAdvisor/getPayoutHistory')
}

export const getPayoutDeniedBankNames = async (): Promise<AxiosResponse<ResponseData<{ payoutDeniedBankNames: string[] }>>> => {
    return await httpClient.get('/avenAdvisor/getPayoutDeniedBankNames')
}

export const getFreeCoffeeGiftCardHistory = async (): Promise<AxiosResponse<ResponseData<{ allIssuedFreeCoffeeGiftCardInfo: IssuedGiftCardInfo[] }>>> => {
    const freeCoffeeGiftCardInfo = await httpClient.get('/avenAdvisor/getAllIssuedFreeCoffeeGiftCardInfo')
    return freeCoffeeGiftCardInfo
}

let getOwnwellSavingsEstimatePromise: Promise<AxiosResponse<ResponseData<{ savingsEstimate: number } | null>>> | null = null

export const getOwnwellSavingsEstimate = async (): Promise<AxiosResponse<ResponseData<{ savingsEstimate: number } | null>>> => {
    if (!getOwnwellSavingsEstimatePromise) {
        log.info('Fetching ownwell savings estimate')
        getOwnwellSavingsEstimatePromise = httpClient.get('/avenAdvisor/getOwnwellSavingsEstimate')
        getOwnwellSavingsEstimatePromise.finally(() => {
            getOwnwellSavingsEstimatePromise = null
        })
    }
    log.info('Returning ownwell savings estimate promise')
    return await getOwnwellSavingsEstimatePromise
}

let investmentHoldingPromise: Promise<AxiosResponse<ResponseData<AvenAdvisorInvestmentHoldingsResponse>>> | null = null

export const getInvestmentHoldings = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorInvestmentHoldingsResponse>>> => {
    if (!investmentHoldingPromise) {
        log.info('Fetching investment holdings')
        investmentHoldingPromise = httpClient.get('/avenAdvisor/getInvestmentHoldings')
        investmentHoldingPromise.finally(() => {
            investmentHoldingPromise = null
        })
    }
    log.info('Returning investment holdings promise')
    return await investmentHoldingPromise
}

export const getPersonaStatus = async (): Promise<AxiosResponse<ResponseData<{ personaStatus: PersonaStatus }>>> => {
    return await httpClient.get('/avenAdvisor/checkAccountPersonaStatus')
}

export const getPersonaLink = async (): Promise<AxiosResponse<ResponseData<{ getPersonaLink: string }>>> => {
    return await httpClient.get('/avenAdvisor/getPersonaLink')
}

export enum BenzingaCongressionalChamber {
    HOUSE = 'House',
    SENATE = 'Senate',
}

let notableTradesPromise: Promise<AxiosResponse<ResponseData<{ notableTrades: AvenAdvisorNotablePersonTrades[] }>>> | null = null

export const getNotableTrades = async (): Promise<AxiosResponse<ResponseData<{ notableTrades: AvenAdvisorNotablePersonTrades[] }>>> => {
    if (!notableTradesPromise) {
        log.info('Fetching notable trades')
        notableTradesPromise = httpClient.get('/avenAdvisor/getNotableTrades')
        notableTradesPromise.finally(() => {
            notableTradesPromise = null
        })
    }
    log.info('Returning notable trades promise')
    return await notableTradesPromise
}

let getCrimeReportPromise: Promise<AxiosResponse<ResponseData<{ crimeReport: NeighborhoodCrimeData } | null>> | null> | null = null

export const getCrimeReport = async (forceRefresh: boolean, limit: number): Promise<AxiosResponse<ResponseData<{ crimeReport: NeighborhoodCrimeData } | null>> | null> => {
    if (!getCrimeReportPromise) {
        log.info('Fetching crime report')
        getCrimeReportPromise = httpClient.get('/avenAdvisor/getCrimeReport', { params: { forceRefresh, limit } })
        getCrimeReportPromise.finally(() => {
            getCrimeReportPromise = null
        })
    }
    log.info('Returning crime report promise')
    return await getCrimeReportPromise
}

let getLienInfoPromise: Promise<AxiosResponse<ResponseData<{ lienInfo: LienInfo } | null>>> | null = null

export const getLienInfo = async (): Promise<AxiosResponse<ResponseData<{ lienInfo: LienInfo } | null>>> => {
    if (!getLienInfoPromise) {
        log.info('Fetching lien info')
        getLienInfoPromise = httpClient.get('/avenAdvisor/getLienInfo')
        getLienInfoPromise.finally(() => {
            getLienInfoPromise = null
        })
    }
    log.info('Returning lien info promise')
    return await getLienInfoPromise
}

let getHomeEquityPromise: Promise<AxiosResponse<ResponseData<{ homeEquityInfo: HomeEquityInfo } | null>>> | null = null

export const getHomeEquityInfo = async (): Promise<AxiosResponse<ResponseData<{ homeEquityInfo: HomeEquityInfo } | null>>> => {
    if (!getHomeEquityPromise) {
        log.info('Fetching home equity info')
        getHomeEquityPromise = httpClient.get('/avenAdvisor/getHomeEquityInfo')
        getHomeEquityPromise.finally(() => {
            getHomeEquityPromise = null
        })
    }
    log.info('Returning home equity info promise')
    return await getHomeEquityPromise
}

export const getExpiredPlaidItems = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorExpiredPlaidItemsResponse>>> => {
    return await httpClient.get('/avenAdvisor/getExpiredPlaidItems')
}

let getCraigslistListingsPromise: Promise<AxiosResponse<ResponseData<{ allListings: CraigslistListingItem[] }>>> | null = null
export const getCraigslistListings = async (): Promise<AxiosResponse<ResponseData<{ allListings: CraigslistListingItem[] }>>> => {
    if (!getCraigslistListingsPromise) {
        log.info('Fetching craigslist listings')
        getCraigslistListingsPromise = httpClient.get('/avenAdvisor/getCraigslistListings')
        getCraigslistListingsPromise.finally(() => {
            getCraigslistListingsPromise = null
        })
    }
    log.info('Returning craigslist listings promise')
    return await getCraigslistListingsPromise
}

let getPushNotificationPromise: Promise<AxiosResponse<ResponseData<{ pushNotifications: AvenAdvisorPushNotificationCenterItem[] }>>> | null = null
export const getPushNotifications = async (): Promise<AxiosResponse<ResponseData<{ pushNotifications: AvenAdvisorPushNotificationCenterItem[] }>>> => {
    if (!getPushNotificationPromise) {
        log.info('Fetching push notifications')
        getPushNotificationPromise = httpClient.get('/avenAdvisor/getPushNotifications')
        getPushNotificationPromise.finally(() => {
            getPushNotificationPromise = null
        })
    }
    log.info('Returning push notifications promise')
    return await getPushNotificationPromise
}

export const logPushNotificationClick = async (pushNotificationId: number): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/logPushNotificationClick', { pushNotificationId })
}

export const getLatestLienReport = async (forceNewFetch: boolean = false): Promise<FetchAvenAdvisorLienReportResponse | null> => {
    const response = await httpClient.get('/avenAdvisor/getLatestLienReportDataForAddress', { params: { forceNewFetch: forceNewFetch ? 'true' : 'false' } })

    if (!response.data || !response.data.success || !response.data.payload) {
        return null
    }

    return {
        ...response.data.payload,
        updatedAt: response.data.payload.updatedAt ? new Date(response.data.payload.updatedAt) : undefined,
    }
}

export const getAvenAdvisorCreditCardRecommendations = async (): Promise<AvenAdvisorCreditCardRecommendationData[]> => {
    const results = (await httpClient.get('/avenAdvisor/getAllRecommendedCreditCards')) as AxiosResponse<ResponseData<AvenAdvisorCreditCardRecommendationData[]>>
    return results.data.payload
}

export const postGoogleOfflineConversion = async (phoneNumber: string, googleConversion: GoogleConversionName): Promise<AxiosResponse<ResponseData<null>> | null> => {
    if (!phoneNumber) {
        log.warn('phoneNumber or googleConversion is undefined')
        return null
    }

    // Instead of throwing we should log the error and return null so
    // we dont blow up execution for the caller. This function is not critical
    try {
        return await httpClient.post('/avenAdvisor/googleOfflineConversion', {
            phoneNumber,
            googleConversion,
        })
    } catch (error) {
        log.error('Failed to post google offline conversion for phone number %{phoneNumber} and googleConversion %{googleConversion}', { phoneNumber, googleConversion, error })
        return null
    }
}

export const postFacebookOfflineConversion = async (phoneNumber: string, facebookPixelStep: FacebookPixelStep): Promise<AxiosResponse<ResponseData<null>> | null> => {
    if (!phoneNumber) {
        log.warn('phoneNumber or facebookPixelStep is undefined')
        return null
    }

    // Instead of throwing we should log the error and return null so
    // we dont blow up execution for the caller. This function is not critical
    try {
        return await httpClient.post('/avenAdvisor/facebookOfflineConversion', {
            phoneNumber,
            facebookPixelStep,
        })
    } catch (error) {
        log.error('Failed to post facebook offline conversion for phone number %{phoneNumber} and facebookPixelStep %{facebookPixelStep}', { phoneNumber, facebookPixelStep, error })
        return null
    }
}

export const maybeInitializeMethodFi = async (): Promise<AxiosResponse<ResponseData<InitializeMethodFiResult>>> => {
    return await httpClient.post('/avenAdvisor/maybeInitializeMethodFi')
}

export const pollForSweepstakesV2PublicWinners = async (): Promise<PublicSweepstakesV2Winner[]> => {
    const response = await httpClient.get('/avenAdvisor/pollForPublicSweepstakesV2Winner')
    return response.data.payload
}

export const employeeRefreshMethodFiEntity = async (): Promise<AxiosResponse<ResponseData<null>> | null> => {
    return await httpClient.post('/avenAdvisor/employeeRefreshMethodFiEntity')
}

export const getIsPlaidAuthenticatedForSweepstakes = async (): Promise<AxiosResponse<ResponseData<{ isPlaidAuthenticated: boolean }>> | null> => {
    return await httpClient.get('/avenAdvisor/getIsPlaidAuthenticatedForSweepstakes')
}

export const optOutSweepstakesV2 = async (): Promise<AxiosResponse<ResponseData<null>> | null> => {
    return await httpClient.post('/avenAdvisor/optOutOfSweepstakesV2')
}

export const convertWebOG = async (): Promise<AxiosResponse<ResponseData<null>> | null> => {
    return await httpClient.post('/avenAdvisor/convertWebOG')
}

export const searchAmazonProducts = async (request: AmazonAffiliateSearchRequest): Promise<AxiosResponse<ResponseData<AmazonAffiliateSearchResult>> | null> => {
    return await httpClient.post('/avenAdvisor/searchAmazonProducts', request)
}

export const recordSaleIntent = async (request: AmazonAffiliateLinkRequest): Promise<AxiosResponse<ResponseData<{ redirectUrl: string }>> | null> => {
    return await httpClient.post('/avenAdvisor/recordAmazonSaleIntent', request)
}

export const recordSaleIntentForPubAdHub = async (request: PubAdHubAffiliateLinkRequest): Promise<AxiosResponse<ResponseData<{ redirectUrl: string }>> | null> => {
    return await httpClient.post('/avenAdvisor/recordSaleIntentForPubAdHub', request)
}

export const getBorrowingCapacityData = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorBorrowingCapacityData>>> => {
    return await httpClient.get('/avenAdvisor/getBorrowingCapacity')
}

export const calculateInitialBorrowingCapacity = async (): Promise<AxiosResponse<ResponseData<{ success: boolean; snapshotsInserted: number }>>> => {
    return await httpClient.post('/avenAdvisor/calculateInitialBorrowingCapacity')
}

export const getFreeCoffeeInfo = async (): Promise<AxiosResponse<ResponseData<FreeCoffeeInfoResponse>> | null> => {
    return await httpClient.get('/avenAdvisor/getFreeCoffeeInfo')
}

export const getFreeCoffeeSelection = async (): Promise<AxiosResponse<ResponseData<{ selectedFreeCoffeeType: FreeCoffeeType | null }>> | null> => {
    return await httpClient.get('/avenAdvisor/getFreeCoffeeSelection')
}

export const redeemFreeCoffee = async (): Promise<AxiosResponse<ResponseData<RedeemFreeCoffeeResponse>> | null> => {
    return await httpClient.post('/avenAdvisor/redeemFreeCoffee')
}

export const getFreeStuffEvaluationJobInfo = async (freeStuffPolicyCategory: FreeStuffPolicyCategory, jobId?: string): Promise<AxiosResponse<ResponseData<FreeStuffEvaluationJobInfo>>> => {
    return await httpClient.post('/avenAdvisor/getFreeStuffEvaluationJobInfo', { freeStuffPolicyCategory, jobId })
}

export const getAffiliateRewardsLedger = async (startDate: Date, endDate: Date): Promise<AxiosResponse<ResponseData<{ ledger: AvenAffiliateRewardsPointsLedgerItem[] } | null>>> => {
    return await httpClient.get('/avenAdvisor/getAffiliateRewardsPointsLedger', { params: { startDate: startDate.toISOString(), endDate: endDate.toISOString() } })
}

export const getSaleInfoFromAffiliateSaleId = async (affiliateSaleId: number): Promise<AxiosResponse<ResponseData<AvenAffiliateSaleInfo | null>>> => {
    return await httpClient.get('/avenAdvisor/getSaleInfoFromAffiliateSaleId', { params: { affiliateSaleId } })
}

export const redeemPointsForAdvisorLead = async (numPoints: number): Promise<AxiosResponse<ResponseData<{ signOnBonus: any } | null>>> => {
    return await httpClient.post('/avenAdvisor/redeemPointsForAdvisorLead', { numPoints })
}

export const refreshVehicles = async (): Promise<AxiosResponse<ResponseData<{ vehicle: VehicleInformation } | null>>> => {
    return await httpClient.post('/avenAdvisor/refreshVehicles')
}

export const joinWaitlistForFeature = async (feature: AvenAdvisorWaitlistedFeature): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/joinWaitlistForFeature', { feature })
}

export const getExperianPullWithTrendedTradelines = async (): Promise<AxiosResponse> => {
    return await httpClient.get('/avenAdvisor/getExperianPullWithTrendedTradelines')
}

export const getExperianPullWithPremierAttributes = async (forceEvenIfCached: boolean): Promise<AxiosResponse> => {
    return await httpClient.post('/avenAdvisor/getCreditReportWithPA', { forceEvenIfCached })
}

export const getIsPlaidConnected = async (): Promise<AxiosResponse<ResponseData<{ connected: boolean }>>> => {
    const response = await httpClient.get('/avenAdvisor/getPlaidConnectionStatusForAdvisor')
    return response.data.payload?.connected ?? false
}

export const getSupportedCoffeeStates = async (): Promise<AxiosResponse<ResponseData<{ states: StateTwoLetterCodes[] }>>> => {
    return await httpClient.get('/avenAdvisor/getSupportedCoffeeStates')
}

export const joinWaitlistWithStateAndPhoneNumber = async (feature: AvenAdvisorWaitlistedFeature, state: StateTwoLetterCodes, phoneNumber: string): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/joinWaitlistWithStateAndPhoneNumber', { feature, state, phoneNumber })
}

export const getPromoAssignments = async (): Promise<AxiosResponse<ResponseData<{ promos: AvenAdvisorPromoName[] }>>> => {
    return await httpClient.get('/avenAdvisor/getPromoAssignments')
}

// this function returns straight html text
export const getLegalDocumentHtml = async (docType: string, ssn?: string): Promise<AxiosResponse<string>> => {
    if (store.state.persistedStore.jwtTokens) {
        return await httpClient.post('/avenAdvisor/getLegalDocumentHtml', { docType, ssn })
    } else {
        return await httpClient.post('/avenAdvisor/getUnauthenticatedLegalDocumentHtml', { docType })
    }
}

export const ackLegalDocument = async (docType: string, ackMetadata: SignDocumentPayload, additionalAcknowledgements?: string): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/acknowledgeLegalDocument', { docType, ackMetadata, additionalAcknowledgements })
}

export const createThirdPartyLead = async (): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/createThirdPartyLead')
}

export const getHomeownershipVerificationDocumentReviewUrlForAdvisorLead = async (): Promise<AxiosResponse<ResponseData<{ url: string }>>> => {
    return await httpClient.post('/avenAdvisor/getHomeownershipVerificationDocumentReviewUrl')
}

interface GetEmbeddedAdDataFromAvenFinancialRequest {
    placement: AdvisorEmbeddedAdPlacement
}

export const getEmbeddedAdDataFromAvenFinancial = async (
    request: GetEmbeddedAdDataFromAvenFinancialRequest
): Promise<AxiosResponse<ResponseData<{ embeddedAdData: AvenFinancialAdCreativeInfo[] }>>> => {
    const { placement = AdPlacement.todayFeed } = request
    const queryParams = new URLSearchParams()
    queryParams.set('placement', placement)

    return await httpClient.get(`/avenAdvisor/getEmbeddedAdDataFromAvenFinancial?${queryParams.toString()}`)
}

export const getInterstitialVideoAdUrl = async (): Promise<AxiosResponse<ResponseData<{ url: string }>>> => {
    return await httpClient.get('/avenAdvisor/getIntersitialVideoAdUrl')
}

export const getInCardCTAUrl = async (ctaPlacement: AdvisorEmbeddedCTAPlacement): Promise<AxiosResponse<ResponseData<{ url: string }>>> => {
    const queryParams = new URLSearchParams()
    queryParams.set('ctaPlacement', ctaPlacement)
    return await httpClient.get(`/avenAdvisor/getInCardCTAUrl?${queryParams.toString()}`)
}

export const hasStartedIrsFormVerification = async (): Promise<AxiosResponse<ResponseData<IrsFormVerificationStatus>>> => {
    return await httpClient.get('/avenAdvisor/hasStartedIrsFormVerification')
}

export const getHomeOwnershipVerificationStatus = async (): Promise<AxiosResponse<ResponseData<{ homeOwnershipVerificationStatus: HomeOwnershipVerificationStatus }>>> => {
    return await httpClient.get('/avenAdvisor/verifyAdvisorLeadHomeownership')
}

export const isUnfreezeExperianButtonOnCooldown = async (): Promise<AxiosResponse<ResponseData<{ isUnfreezeExperianButtonOnCooldown: boolean | null } | null>>> => {
    return await httpClient.get('/avenAdvisor/isUnfreezeExperianButtonOnCooldown')
}

export const getFreeCoffeeSelectionByPolicy = async (): Promise<AxiosResponse<ResponseData<{ freeCoffeeType: FreeCoffeeType | null }>> | null> => {
    return await httpClient.get('/avenAdvisor/getFreeCoffeeTypeByFreeStuffPolicy')
}

const getRedeemFreeCoffeePolicifedJobInfo = async (jobId?: string): Promise<RedeemFreeCoffeePolicifiedResponse | null> => {
    const response = await httpClient.post('/avenAdvisor/redeemFreeCoffeePolicified', { jobId })
    if (!response.data || !response.data.success || !response.data.payload) {
        return null
    }
    return response.data.payload
}

export const redeemFreeCoffeePolicified = async (): Promise<string | null> => {
    log.info('redeemFreeCoffeePolicified => redeeming free coffee')
    let jobInfo = await getRedeemFreeCoffeePolicifedJobInfo()
    const startTime = new Date().getTime()

    const MAX_WAIT_TIME_FOR_JOB_TO_FINISH_MS = 120 * 1000 // 2 minutes - this is the P95 time taken for plaid asset report to load
    const TIME_TO_WAIT_MS = 2_000 // milliseconds
    while (jobInfo && jobInfo.continuePolling) {
        jobInfo = await getRedeemFreeCoffeePolicifedJobInfo(jobInfo.jobId)
        log.info('redeemFreeCoffeePolicified => jobInfo: %{jobInfoInspect}', { jobInfoInspect: inspect(jobInfo) })

        const elapsedTime = new Date().getTime() - startTime
        if (elapsedTime > MAX_WAIT_TIME_FOR_JOB_TO_FINISH_MS) {
            log.warn('redeemFreeCoffeePolicified => did not finish in %{maxWaitTime}ms. Going to stop polling.', { maxWaitTime: MAX_WAIT_TIME_FOR_JOB_TO_FINISH_MS })
            break
        }

        await new Promise((resolve) => setTimeout(resolve, TIME_TO_WAIT_MS))
    }
    if (!jobInfo || !jobInfo.issuedGiftCardUrl) {
        log.warn('redeemFreeCoffeePolicified => was not successful. jobInfo: %{jobInfoInspect}', { jobInfoInspect: inspect(jobInfo) })
        return null
    }
    log.info('redeemFreeCoffeePolicified => successfully redeemed free coffee. jobInfo: %{jobInfoInspect}', { jobInfoInspect: inspect(jobInfo) })
    return jobInfo.issuedGiftCardUrl
}

export const getFreeFreeStuffPolicyByCategory = async (freeStuffPolicyCategory: FreeStuffPolicyCategory): Promise<AxiosResponse<ResponseData<FreeStuffPolicy | null>>> => {
    return await httpClient.post('/avenAdvisor/getFreeFreeStuffPolicyByCategory', { freeStuffPolicyCategory })
}

export const getIrsEmbedUrlForAdvisor = async (): Promise<AxiosResponse<ResponseData<{ embedLink: string }>>> => {
    return await httpClient.get('/avenAdvisor/getIrsEmbedUrlForAdvisor')
}

export const getLargePurchaseAdviceFormattedAndAdCreative = async (
    transactionId: number,
    transactionType: UnifiedTransactionType
): Promise<AxiosResponse<ResponseData<{ largePurchaseAdvice: LargePurchaseAdviceFormatted; embeddedAdData: AvenFinancialAdCreativeInfo | null }>>> => {
    return await httpClient.get('/avenAdvisor/getlargePurchaseAdviceFormattedAndAdCreative', { params: { transactionId, transactionType } })
}

export const recordAvenAdvisorLiabilityQuizAnswers = async (payload: {
    interestRate: number | null
    monthlyPayment: number | null
    interestedInRefinancing: boolean | null
    liabilityType: AvenAdvisorLiabilityQuizLiabilityType
    hasLiability: boolean
    quizType: AvenAdvisorLiabilityQuizType
}): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/recordAvenAdvisorLiabilityQuizAnswers', payload)
}

export const getMostRecentLiabilityQuizAnswers = async (payload: {
    liabilityType: AvenAdvisorLiabilityQuizLiabilityType
    quizType: AvenAdvisorLiabilityQuizType
}): Promise<AxiosResponse<ResponseData<AvenAdvisorLiabilityQuizAnswersInfo | null>>> => {
    return await httpClient.post('/avenAdvisor/getMostRecentLiabilityQuizAnswers', payload)
}

export {
    getSessionInfo,
    requestTwoFactor,
    routeToAuthFlow,
    checkTwoFa,
    checkTwoFaForPhoneNumberChange,
    createAccount,
    MARITAL_STATUS_TO_TEXT,
    HOME_OWNERSHIP_STATUS_TO_TEXT,
    signIn,
    resetPassword,
    getTotalDebt,
    getInviteCode,
    plaidReportFetchState,
    startPlaidReportFetch,
    updateSocialSecurity,
    getPayoutsAccountSetUpLink,
    initiateCreditOffer,
    pollForCreditOffers,
    getIllustrativeSavingsExample,
}
